import {VarcharDatatypeInterface} from '../postgresql/varchar-datatype.model';

export interface RevisionDataFieldInterface extends VarcharDatatypeInterface {
  data?: string;
}

export class RevisionDataFieldClass extends String
  implements RevisionDataFieldInterface {
  data?: string;
  max_length?: number;
  not_null?: boolean;
  is_unique?: boolean;
  default_value?: string;
}
